export const openWhatsapp = (number) => {
    window.open(`https://wa.me/51${number}`, '_blank');
};

export const openGmail = (mail) =>
    window.open(`https://mail.google.com/mail/u/0/?view=cm&fs=1&to=${mail}`, '_blank');

export const openGmailWithSubject = (mail, subject) =>
    window.open(`https://mail.google.com/mail/u/0/?view=cm&fs=1&to=${mail}&su=${subject}`, '_blank');
